export default "__VITE_ASSET__CWPDBFFB__"